import React from 'react';
import { ProductTypes } from '../../../../types/product/product';
import ProductListPresentation from './ProductListPresentation/ProductListPresentation';
import ProductListActions from './ProductListActions/ProductListActions';
import { FeatureContainer } from '../../Containers/FeatureContainer';
import { ButtonWithText } from '../../../atoms/Buttons/ButtonWithText';
import { classNames } from 'helpers/style/classNames';
import useStyle from './productListView.style';

export interface ProductListViewProps {
  product: ProductTypes;
  setProductQuantity: (n: number) => void;
  onAddToCart: () => void;
  onClick: () => void;
  isOut?: boolean;
  isPublicShop: boolean;
}

const ProductListView = ({
  product,
  setProductQuantity,
  onAddToCart,
  onClick,
  isOut = false,
  isPublicShop
}: ProductListViewProps) => {
  const classes = useStyle();

  return (
    <FeatureContainer
      buttonWithText={
        <ButtonWithText
          variant={'text'}
          content={'Fiche produit'}
          icon={'MoreAbout'}
          onClick={onClick}
        />
      }
      iconButton={null}
      buttonPosition={'bottomRight'}
    >
      <div
        className={classNames(
          [classes.root],
          [
            {
              condition: isOut,
              classe: classes.empty
            }
          ]
        )}
      >
        <ProductListPresentation
          product={product}
          isPublicShop={isPublicShop}
          onClick={onClick}
        />
        {!isOut ? (
          <div className={classes.productActions}>
            <ProductListActions
              setProductQuantity={setProductQuantity}
              onAddToCart={onAddToCart}
            />
          </div>
        ) : (
          <p className={classes.isOutText}>Produit épuisé.</p>
        )}
      </div>
    </FeatureContainer>
  );
};

export default ProductListView;
